import app from 'flarum/forum/app';
import { compat } from '@flarum/core/forum';
import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import UserCard from 'flarum/forum/components/UserCard';
import Message from './models/Message';
import Conversation from './models/Conversation';
import ConversationUser from './models/ConversationUser';
import User from 'flarum/common/models/User';
import Model from 'flarum/common/Model';
import ConversationsPage from './components/ConversationsPage';
import ConversationViewPage from './components/ConversationViewPage';
import UserPageButton from "./components/UserPageButton";
import Stream from 'flarum/common/utils/Stream';
import EventEmitter from 'flarum/common/utils/EventEmitter';

import addConversationsDropdown from './addConversationsDropdown';

app.initializers.add('kyrne-whisper', function (app) {
  const { default: vnodeHelpers } = compat['extensions/foghour-helpers/vnodeHelpers'];
  const searchNodeByClass = vnodeHelpers.searchNodeByClass;

  if (!app.eventEmitter)
    app.eventEmitter = new EventEmitter();

  app.store.models.messages = Message;
  app.store.models.conversations = Conversation;
  app.store.models.conversation_users = ConversationUser;

  User.prototype.conversations = Model.hasMany('conversations');
  User.prototype.unreadMessages = Model.attribute('unreadMessages');

  app.routes.conversations = { path: '/whisper/conversations', component: ConversationsPage };
  app.routes.messages = { path: '/whisper/messages/:id', component: ConversationViewPage };

  addConversationsDropdown();

  extend(IndexPage.prototype, 'oncreate', function () {
    if (app.pusher) {
      app.pusher.then((object) => {
        const channels = object.channels;
        if (channels.user) {
          channels.user.bind('newMessage', (data) => {
            app.session.user.unreadMessages = Stream(app.session.user.unreadMessages() + 1);
            m.redraw();
          });
        }
      });
    }
  });

  extend(IndexPage.prototype, 'onremove', function () {
    if (app.pusher) {
      app.pusher.then((object) => {
        const channels = object.channels;
        if (channels.user) {
          channels.user.unbind('newMessage');
        }
      });
    }
  });

  extend(UserCard.prototype, 'view', function (vnode) {
    if (app.session.user === null) return;

    let currentUser = this.attrs.user || app.current.get('user');
    if (currentUser === app.session.user) return;

    let identityContainer = searchNodeByClass(vnode, 'UserCard-identity');
    if (!!identityContainer)
    {
      identityContainer.children.push(<UserPageButton currentUser={currentUser} />);
    }
  });
});
